// ----------------------------------------------------------------------
// <copyright file="Izenda.Destination.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Destination component
 */
!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var constants = require('logic/data/Izenda.ImportDataModelConstants');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var Select = Validator()(require('share/components/controls/multiSelectBox/Izenda.Select'));

  var Destination = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    render: function() {
      var props = this.props;
      var store = props.store;
      var localization = props.localization;

      return (
        <div className="u_table u_fullWidth">
          <div className="u_tableCell u_alignMiddle u_paddingRight">{localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_DESTINATION')}</div>
          <div className="u_tableCell u_fullWidth u_alignMiddle">
            <Select
              multi={true}
              simpleValue
              options={store.dataModelImport.allDestinationTenantList}
              labelKey="name"
              valueKey="id"
              noResultsText="No result"
              onChange={this.updateSelectedTenant}
              allowCreate={false}
              value={store.dataModelImport.selectedDestinationTenantIDs}
              validations={constants.DESTINATION_CONSTRAINTS}
              blankOption={true}
            />
          </div>
        </div>
      );
    },

    updateSelectedTenant: function(tenantId) {
      var store = this.props.store;
      store.dataModelImport.updateSelectedTenantsForDestination(tenantId);
    }
  });

  module.exports = connect()(Destination);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/DataModel/Izenda.Destination.jsx